"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var text_overflow_clamp_1 = tslib_1.__importDefault(require("../../../../common/utils/text-overflow-clamp"));
var get_resized_image_url_1 = tslib_1.__importDefault(require("../../../../common/utils/get-resized-image-url"));
var scrollbar_wrapper_1 = tslib_1.__importDefault(require("../../../ui-components/scrollbar-wrapper/scrollbar-wrapper"));
var info_scss_1 = tslib_1.__importDefault(require("./info.scss"));
var withStyles_1 = require("../../../utils/withStyles");
var POSTER_SIZE = {
    width: 303,
    height: 449,
};
var POSTER_SIZE_FULLSCREEN = {
    width: 450,
    height: 667,
};
// NOTE: Expected translated values at props (because of differrent translations at embed and widget)
var InfoOverlayInfo = /** @class */ (function (_super) {
    tslib_1.__extends(InfoOverlayInfo, _super);
    function InfoOverlayInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = null;
        _this.info = null;
        _this.posterEl = null;
        _this.savePosterRef = function (node) {
            _this.posterEl = node;
        };
        _this.saveTitleRef = function (node) {
            _this.title = node;
        };
        _this.setPosterSize = function () {
            var isInFullScreen = _this.props.isInFullScreen;
            _this.updatePosterStyle(isInFullScreen ? POSTER_SIZE_FULLSCREEN : POSTER_SIZE);
        };
        return _this;
    }
    InfoOverlayInfo.prototype.componentDidMount = function () {
        this.clamp();
        this.setPosterSize();
    };
    InfoOverlayInfo.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.title && prevProps.title !== this.props.title) {
            this.clamp();
        }
        if (prevProps.isInFullScreen !== this.props.isInFullScreen) {
            this.setPosterSize();
        }
    };
    InfoOverlayInfo.prototype.clamp = function () {
        if (!this.title) {
            return;
        }
        text_overflow_clamp_1.default(this.title, { lineClamp: 3 });
    };
    InfoOverlayInfo.prototype.getRoles = function (rolesType, title) {
        var _a = rolesType, roles = this.props[_a];
        if (!roles || !roles.length) {
            return null;
        }
        var roleElements = roles.map(function (_a, index) {
            var role = _a.role, name = _a.name;
            if (!role) {
                return null;
            }
            return (react_1.default.createElement("div", { key: index, "data-hook": "overlay-info-" + rolesType, className: info_scss_1.default['role-item'] },
                react_1.default.createElement("div", { className: info_scss_1.default.role }, role),
                react_1.default.createElement("div", { className: info_scss_1.default.name }, name)));
        });
        return (react_1.default.createElement("div", { className: info_scss_1.default['roles-wrapper'] },
            react_1.default.createElement("div", { className: info_scss_1.default['roles-title'] }, title),
            roleElements));
    };
    InfoOverlayInfo.prototype.updatePosterStyle = function (_a) {
        var width = _a.width, height = _a.height;
        var poster = this.posterEl;
        if (!poster) {
            return null;
        }
        poster.style.width = Math.floor((poster.offsetHeight / height) * width) + "px";
    };
    InfoOverlayInfo.prototype.getPosterImage = function (width, height, className) {
        var _a;
        var _b = this.props, posterUrl = _b.posterUrl, isInFullScreen = _b.isInFullScreen, imageHost = _b.imageHost;
        if (!posterUrl) {
            return null;
        }
        var resizedPosterUrl = get_resized_image_url_1.default({
            url: posterUrl,
            width: width * 2,
            height: height * 2,
            imageHost: imageHost,
        });
        var classNames = classnames_1.default(info_scss_1.default.poster, className, (_a = {},
            _a[info_scss_1.default.fullscreen] = isInFullScreen,
            _a));
        return (react_1.default.createElement("div", { ref: this.savePosterRef, className: classNames, "data-hook": "overlay-info-poster", style: { backgroundImage: "url(" + resizedPosterUrl + ")" } }));
    };
    Object.defineProperty(InfoOverlayInfo.prototype, "compactPoster", {
        get: function () {
            var _a = this.props, posterUrl = _a.posterUrl, title = _a.title, imageHost = _a.imageHost;
            if (!posterUrl) {
                return null;
            }
            var resizedPosterUrl = get_resized_image_url_1.default({
                url: posterUrl,
                width: POSTER_SIZE.width * 2,
                height: POSTER_SIZE.height * 2,
                imageHost: imageHost,
            });
            return (react_1.default.createElement("img", { className: info_scss_1.default.poster + " " + info_scss_1.default['poster-compact'], "data-hook": "overlay-info-poster-compact", src: resizedPosterUrl, alt: title }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "poster", {
        get: function () {
            var isInFullScreen = this.props.isInFullScreen;
            if (isInFullScreen) {
                return null;
            }
            return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "fullScreenPoster", {
        get: function () {
            var isInFullScreen = this.props.isInFullScreen;
            if (!isInFullScreen) {
                return null;
            }
            return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "publisher", {
        get: function () {
            var _a;
            var _b = this.props, publisher = _b.publisher, isRTL = _b.isRTL;
            if (!publisher) {
                return null;
            }
            var publisherStyles = classnames_1.default(info_scss_1.default['info-item'], (_a = {},
                _a[info_scss_1.default.rtl] = isRTL,
                _a[info_scss_1.default.ltr] = !isRTL,
                _a));
            return (react_1.default.createElement("div", { className: publisherStyles, "data-hook": "overlay-info-publisher" }, publisher));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "genre", {
        get: function () {
            var _a;
            var _b = this.props, genre = _b.genre, isRTL = _b.isRTL;
            if (!genre) {
                return null;
            }
            var genreStyles = classnames_1.default(info_scss_1.default['info-item'], (_a = {},
                _a[info_scss_1.default.rtl] = isRTL,
                _a[info_scss_1.default.ltr] = !isRTL,
                _a));
            return (react_1.default.createElement("div", { className: genreStyles, "data-hook": "overlay-info-genres" }, genre));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "videoType", {
        get: function () {
            var _a;
            var _b = this.props, videoType = _b.videoType, isRTL = _b.isRTL;
            if (!videoType) {
                return null;
            }
            var videoTypeStyles = classnames_1.default(info_scss_1.default['info-item'], (_a = {},
                _a[info_scss_1.default.rtl] = isRTL,
                _a[info_scss_1.default.ltr] = !isRTL,
                _a));
            return (react_1.default.createElement("div", { className: videoTypeStyles, "data-hook": "overlay-info-video-type" }, videoType));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "duration", {
        get: function () {
            var _a;
            var _b = this.props, durationStr = _b.durationStr, durationAriaLabel = _b.durationAriaLabel, isRTL = _b.isRTL;
            if (!durationStr) {
                return null;
            }
            var durationStyles = classnames_1.default(info_scss_1.default['info-item'], (_a = {},
                _a[info_scss_1.default.rtl] = isRTL,
                _a[info_scss_1.default.ltr] = !isRTL,
                _a));
            return (react_1.default.createElement("div", { className: durationStyles, "data-hook": "overlay-info-duration", "aria-label": durationAriaLabel }, " " + durationStr));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoOverlayInfo.prototype, "description", {
        get: function () {
            var description = this.props.description;
            if (!description) {
                return null;
            }
            return (react_1.default.createElement("div", { className: info_scss_1.default.description, "data-hook": "overlay-info-description" }, description));
        },
        enumerable: true,
        configurable: true
    });
    InfoOverlayInfo.prototype.render = function () {
        var _a;
        var _b = this.props, title = _b.title, isInFullScreen = _b.isInFullScreen, castTitle = _b.castTitle, crewTitle = _b.crewTitle;
        var styleNames = classnames_1.default(info_scss_1.default.wrapper, (_a = {},
            _a[info_scss_1.default['full-screen']] = isInFullScreen,
            _a));
        return (react_1.default.createElement("div", { className: styleNames, "data-hook": "player-overlay-info" },
            this.poster,
            react_1.default.createElement(scrollbar_wrapper_1.default, { className: info_scss_1.default['scrollbar-wrapper'] },
                react_1.default.createElement("div", { className: info_scss_1.default['main-info'] },
                    react_1.default.createElement("h3", { ref: this.saveTitleRef, className: info_scss_1.default.title, "data-hook": "overlay-info-title", title: title }, title),
                    react_1.default.createElement("div", { className: info_scss_1.default.info },
                        this.publisher,
                        this.genre,
                        this.videoType,
                        this.duration),
                    this.description,
                    this.fullScreenPoster,
                    this.getRoles('cast', castTitle),
                    this.getRoles('crew', crewTitle),
                    this.compactPoster))));
    };
    InfoOverlayInfo = tslib_1.__decorate([
        withStyles_1.withStyles(info_scss_1.default)
    ], InfoOverlayInfo);
    return InfoOverlayInfo;
}(react_1.default.Component));
exports.default = InfoOverlayInfo;
//# sourceMappingURL=info.js.map